"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRecipientResetErrors = exports.createRecipientSetIsUnsubscribed = exports.giftCreateRecipientReset = exports.createRecipientFail = exports.createRecipientSuccess = exports.createRecipientEmailValid = exports.createRecipientEmailInvalid = exports.createRecipientRequestTry = exports.createRecipientRequest = exports.CREATE_GIFT_RECIPIENT_SET_IS_UNSUBSCRIBED = exports.CREATE_GIFT_RECIPIENT_EMAIL_VALID = exports.CREATE_GIFT_RECIPIENT_EMAIL_INVALID = exports.CREATE_GIFT_RECIPIENT_RESET_ERRORS = exports.CREATE_GIFT_RECIPIENT_RESET = exports.CREATE_GIFT_RECIPIENT_CREATE_FAIL = exports.CREATE_GIFT_RECIPIENT_CREATE_SUCCESS = exports.CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY = exports.CREATE_GIFT_RECIPIENT_CREATE_REQUEST = void 0;
var CREATE_GIFT_RECIPIENT_CREATE_REQUEST = 'CREATE_GIFT_RECIPIENT_CREATE_REQUEST';
exports.CREATE_GIFT_RECIPIENT_CREATE_REQUEST = CREATE_GIFT_RECIPIENT_CREATE_REQUEST;
var CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY = 'CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY';
exports.CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY = CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY;
var CREATE_GIFT_RECIPIENT_CREATE_SUCCESS = 'CREATE_GIFT_RECIPIENT_CREATE_SUCCESS';
exports.CREATE_GIFT_RECIPIENT_CREATE_SUCCESS = CREATE_GIFT_RECIPIENT_CREATE_SUCCESS;
var CREATE_GIFT_RECIPIENT_CREATE_FAIL = 'CREATE_GIFT_RECIPIENT_CREATE_FAIL';
exports.CREATE_GIFT_RECIPIENT_CREATE_FAIL = CREATE_GIFT_RECIPIENT_CREATE_FAIL;
var CREATE_GIFT_RECIPIENT_RESET = 'CREATE_GIFT_RECIPIENT_RESET';
exports.CREATE_GIFT_RECIPIENT_RESET = CREATE_GIFT_RECIPIENT_RESET;
var CREATE_GIFT_RECIPIENT_RESET_ERRORS = 'CREATE_GIFT_RECIPIENT_RESET_ERRORS';
exports.CREATE_GIFT_RECIPIENT_RESET_ERRORS = CREATE_GIFT_RECIPIENT_RESET_ERRORS;
var CREATE_GIFT_RECIPIENT_EMAIL_INVALID = 'CREATE_GIFT_RECIPIENT_EMAIL_INVALID';
exports.CREATE_GIFT_RECIPIENT_EMAIL_INVALID = CREATE_GIFT_RECIPIENT_EMAIL_INVALID;
var CREATE_GIFT_RECIPIENT_EMAIL_VALID = 'CREATE_GIFT_RECIPIENT_EMAIL_VALID';
exports.CREATE_GIFT_RECIPIENT_EMAIL_VALID = CREATE_GIFT_RECIPIENT_EMAIL_VALID;
var CREATE_GIFT_RECIPIENT_SET_IS_UNSUBSCRIBED = 'CREATE_GIFT_RECIPIENT_SET_IS_UNSUBSCRIBED';
exports.CREATE_GIFT_RECIPIENT_SET_IS_UNSUBSCRIBED = CREATE_GIFT_RECIPIENT_SET_IS_UNSUBSCRIBED;

var createRecipientRequest = function createRecipientRequest(recipient) {
  return {
    type: CREATE_GIFT_RECIPIENT_CREATE_REQUEST,
    payload: recipient
  };
};

exports.createRecipientRequest = createRecipientRequest;

var createRecipientRequestTry = function createRecipientRequestTry(recipient) {
  var skipEmailVerification = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: CREATE_GIFT_RECIPIENT_CREATE_REQUEST_TRY,
    payload: {
      recipient,
      skipEmailVerification
    }
  };
};

exports.createRecipientRequestTry = createRecipientRequestTry;

var createRecipientEmailInvalid = function createRecipientEmailInvalid() {
  return {
    type: CREATE_GIFT_RECIPIENT_EMAIL_INVALID
  };
};

exports.createRecipientEmailInvalid = createRecipientEmailInvalid;

var createRecipientEmailValid = function createRecipientEmailValid() {
  return {
    type: CREATE_GIFT_RECIPIENT_EMAIL_VALID
  };
};

exports.createRecipientEmailValid = createRecipientEmailValid;

var createRecipientSuccess = function createRecipientSuccess(recipient) {
  return {
    type: CREATE_GIFT_RECIPIENT_CREATE_SUCCESS,
    payload: recipient
  };
};

exports.createRecipientSuccess = createRecipientSuccess;

var createRecipientFail = function createRecipientFail(recipient) {
  return {
    type: CREATE_GIFT_RECIPIENT_CREATE_FAIL,
    payload: recipient
  };
};

exports.createRecipientFail = createRecipientFail;

var giftCreateRecipientReset = function giftCreateRecipientReset() {
  return {
    type: CREATE_GIFT_RECIPIENT_RESET
  };
};

exports.giftCreateRecipientReset = giftCreateRecipientReset;

var createRecipientSetIsUnsubscribed = function createRecipientSetIsUnsubscribed(isUnsubscribed) {
  return {
    type: CREATE_GIFT_RECIPIENT_SET_IS_UNSUBSCRIBED,
    payload: isUnsubscribed
  };
};

exports.createRecipientSetIsUnsubscribed = createRecipientSetIsUnsubscribed;

var createRecipientResetErrors = function createRecipientResetErrors() {
  return {
    type: CREATE_GIFT_RECIPIENT_RESET_ERRORS
  };
};

exports.createRecipientResetErrors = createRecipientResetErrors;